import React from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { useSelector, useDispatch } from "react-redux";
import {
  selectError,
  selectEmail,
  selectAuthStatus,
  postVerifyCode,
} from "../../../utils/auth/authSlice";

import PageWrapper from "../../PageWrapper";
import InputText from "../../GenericFormikComponents/InputText";
import Label from "../../Label";
import PrimaryButton from "../../SFUCentralThemedComponents/PrimaryButton";
import ProgressSpinnerPR from "../../PrimeReact/ProgressSpinnerPR";

export default function VerificationPage() {
  const dispatch = useDispatch();
  const error = useSelector(selectError);
  const email = useSelector(selectEmail);
  const authStatus = useSelector(selectAuthStatus);
  const spinnerStatus = authStatus === "loading";

  return (
    <PageWrapper>
      <Formik
        initialValues={{ verification_code: "" }}
        validationSchema={Yup.object().shape({
          verification_code: Yup.string()
            .nullable()
            .required("Verification Code is required."),
        })} // validation schema is defined at the top of the page
        onSubmit={(values) => {
          dispatch(postVerifyCode({ ...values, email }));
          window.scrollTo(0, 0);
        }}
      >
        <Form>
          <div className="p-grid">
            <div className="p-col-12">
              <h1>Verification Code</h1>
            </div>
            <div className="p-col-12">
              <p>
                A verification code has been sent to your email, please enter it
                below.
              </p>
            </div>

            <div className="p-col-12 p-md-6">
              <Label htmlFor="verification_code">
                <span className="p-col-12 p-col-nogutter">
                  Verification Code
                </span>
                <InputText
                  name="verification_code"
                  placeholder="Enter Verification Code"
                  className="p-col-12"
                />
              </Label>
            </div>

            {error ? (
              <div className="p-col-12">
                <span className="p-invalid">{error}</span>
              </div>
            ) : (
              ""
            )}
          </div>

          <div className="p-grid button-navigation-container">
            <div className="p-col-12">
              <PrimaryButton type="submit" disabled={spinnerStatus}>
                Verify
              </PrimaryButton>
            </div>
          </div>
        </Form>
      </Formik>

      {spinnerStatus ? <ProgressSpinnerPR /> : ""}
    </PageWrapper>
  );
}
